'use strict';
import React, {Component} from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as FlipMoveConfig from '../../../../config/style/FlipMoveListConfig';
import {NotificationItem} from '../NotificationItem';

export class NotificationListComponent extends Component {
  static propTypes = {
    className: T.string,
    list: T.array,
    onRemove: T.func,
  };

  static defaultProps = {
    list: [],
  };

  render() {
    return (
      <div className={classNames("NotificationList", this.props.className)}>
        <div className="NotificationList__scrollArea">
          <div className="NotificationList__scroll">
            <ReactCSSTransitionGroup
              transitionName={FlipMoveConfig.transitionName}
              transitionAppear={FlipMoveConfig.transitionAppear}
              transitionAppearTimeout={FlipMoveConfig.transitionAppearTimeout}
              transitionEnterTimeout={FlipMoveConfig.transitionEnterTimeout}
              transitionLeaveTimeout={FlipMoveConfig.transitionLeaveTimeout}
              className="list"
            >
              {this.props.list ? this.props.list.map(note => (
                <NotificationItem
                  className="NotificationList__item"
                  key={note.__noteId}
                  note={note}
                  onRemove={this.props.onRemove}
                />
              )) : null}
            </ReactCSSTransitionGroup>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/notifications/components/NotificationList/NotificationListComponent.js